import {
  CallCodeModel,
  CallOriginModel,
  ICallCodeModel,
  ICallOriginModel,
  IModel,
  Model,
} from '@common/models';
import { StringUtility } from '@common/utils';
import { DateTime } from 'luxon';
import { AuthUserModel, IAuthUserModel } from './Security';

export const defaultCustomerInteraction: ICustomerInteractionModel = {
  callDate: '2022-08-19T15:39:23.64',
  clientInteractionId: 0,
  callOriginId: 0,
  callCodeId: 0,
  petId: '0',
  clientId: '0',
  notes: '',
  user: new AuthUserModel({}),
  rowVersion: '',
  callOrigin: {
    callOriginId: 0,
    isSystemGenerated: false,
    name: '',
    rowVersion: '',
  },
  callCode: {
    callCodeId: 0,
    isSystemGenerated: false,
    name: '',
    rowVersion: '',
  },
  followUp: false,
  followUpTypeId: 1,
};

export class CustomerInteractionModel
  extends Model
  implements Record<keyof ICustomerInteractionModel, any>
{
  clientInteractionId: number | undefined;
  callOriginId: number;
  callCodeId: number;
  notes: string;
  user: AuthUserModel;
  petId: number;
  clientId: number;
  callOrigin: CallOriginModel;
  callCode: CallCodeModel;
  callDate: DateTime;
  followUp: boolean;
  followUpTypeId: number;
  callOriginName: string;
  callCodeName: string;
  fullName: string;

  constructor(params: ICustomerInteractionModel = defaultCustomerInteraction) {
    super();
    const {
      clientInteractionId,
      callOriginId,
      callCodeId,
      notes,
      user,
      rowVersion,
      petId,
      clientId,
      callOrigin,
      callCode,
      callDate,
      followUp,
      followUpTypeId,
    } = params;
    const { user: actualUser } = user;
    const { firstName, lastName } = actualUser;
    this.clientInteractionId = clientInteractionId;
    this.callOriginId = callOriginId;
    this.callCodeId = callCodeId;
    this.notes = notes;
    this.user = new AuthUserModel(user);
    this.rowVersion = rowVersion;
    this.petId = Number(petId);
    this.clientId = Number(clientId);
    this.callOrigin = new CallOriginModel(callOrigin);
    this.callCode = new CallCodeModel(callCode);
    this.callDate = DateTime.fromISO(callDate, { zone: 'UTC' });
    this.followUp = followUp;
    this.followUpTypeId = followUpTypeId;
    this.callOriginName = callOrigin.name;
    this.callCodeName = callCode.name;
    this.fullName = StringUtility.getFullName({ firstName, lastName });
  }
}
export interface ICustomerInteractionModel extends IModel {
  callDate: string;
  clientInteractionId?: number;
  callOriginId: number;
  callCodeId: number;
  notes: string;
  petId: string;
  clientId: string;
  user: IAuthUserModel;
  callOrigin: ICallOriginModel;
  callCode: ICallCodeModel;
  followUp: boolean;
  followUpTypeId: number;
}
